export default __webpack_public_path__ + "static/media/fish-shrimp-dish.784e64e6.jpg";